import React from 'react';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
export function StickyMobileCTA() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 p-4 shadow-[0_-8px_24px_rgba(0,0,0,0.12)] md:hidden flex gap-3" data-id="element-229">
      <a href="tel:8883417570" className="w-[60px] h-[60px] bg-slate-100 text-[#1B2A4A] rounded-full flex items-center justify-center shrink-0" aria-label="Call us" data-id="element-230">
        <PhoneIcon className="w-6 h-6" data-id="element-231" />
      </a>
      <button onClick={() => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })} className="flex-1 bg-[#E8913A] hover:bg-[#D17E2E] text-white font-bold py-4 px-4 rounded-md flex items-center justify-center text-base transition-colors shadow-lg" data-id="element-232">
        Request Your Offer
        <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-233" />
      </button>
    </div>;
}